import { render } from "./Tabs.vue?vue&type=template&id=04e9ee6b&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=04e9ee6b&lang=scss&scoped=true"
import "./Tabs.vue?vue&type=style&index=1&id=04e9ee6b&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e9ee6b"]])

export default __exports__